import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Logo = function Logo(props) {
    const { image } = props;
    return (
        <div
            className={styles.logo}
            style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
            }}
        />
    );
};

Logo.propTypes = {
    image: PropTypes.string.isRequired,
};

Logo.defaultProps = {
};

export default Logo;
